import React from 'react';

import { toCssSelector } from '@candu-ai/stylesheet/utils';
import { AtomicText } from 'craft/resolvers/AtomicText';

interface FormLabelProps {
  id: string;
  label?: string;
  required?: boolean;
}

export const FormLabel = ({ id, label, required }: FormLabelProps) => {
  const labelClassname = toCssSelector('form', {
    output: 'html',
    className: 'formLabel',
  });

  return (
    <span data-atomictext-node data-nid={id} className={labelClassname}>
      <AtomicText propKey="label" childrenString={label} />
      {required && '*'}
    </span>
  );
};
